import { BRAND } from '../../config/brand'

const titles: Record<string, string> = {
  '/today': "Today's Focus",
  '/motivation': 'Motivation',
  '/horton-ai': BRAND.assistant,
  '/diary': 'Diary',
  '/dreams': 'Dreams',
  '/goals': 'Goals',
  '/skills': 'Skills',
  '/habits': 'Habits',
  '/tasks': 'Tasks',
  '/schedule': 'Schedule',
  '/review-schedule': 'Review Schedule',
  '/dashboard': 'Dashboard',
  '/analytics': 'Your rhythm',
  '/how-horton-helps': `How ${BRAND.assistant} helps me`,
  '/my-people': 'My People',
  '/life-map': 'Life Map',
  '/places': 'My Places',
  '/profile': 'Settings',
  '/billing': 'Billing',
  '/change-password': 'Change Password',
  '/admin': 'Admin',
  '/dev-tools': 'Dev Tools',
  '/dev/automom-activity-log': 'Assistant activity log',
  '/time-travel': 'Time Travel',
  '/theme-builder': 'Theme Builder',
  '/diary-showcase': 'Diary Showcase',
  '/download': 'Get the App',
}

/**
 * Is there a real route behind this exact path? The desktop breadcrumb used to
 * link every path prefix, so segments that are not routes of their own
 * (/habits/occurrences, /my-people/person, /dev, /with-you) dropped the reader
 * on a 404 (2026-08-29). Detail pages under a known collection (/dreams/12)
 * count, so those crumbs keep their link.
 */
export function isNavigableRoute(pathname: string): boolean {
  if (Object.prototype.hasOwnProperty.call(titles, pathname)) return true
  const at = pathname.lastIndexOf('/')
  if (at > 0 && /^\d+$/.test(pathname.slice(at + 1))) {
    return Object.prototype.hasOwnProperty.call(titles, pathname.slice(0, at))
  }
  return false
}

export function getRouteTitle(pathname: string): string {
  if (titles[pathname]) return titles[pathname]
  for (const prefix of Object.keys(titles)) {
    if (pathname.startsWith(prefix + '/')) return titles[prefix]
  }
  const last = pathname.split('/').filter(Boolean).pop() || ''
  return last.charAt(0).toUpperCase() + last.slice(1).replace(/-/g, ' ')
}
